import { lazy } from "react";
import { RouteType, type } from "./components/Router";
import AuthLayout from "./layouts/auth/auth.layout";
import AppLayout from "./layouts/app/app.layout";
import PublicLayout from "./layouts/public/public.layout";

const GenericError = lazy(() => import("./components/ErrorBoundary"));
const Login = lazy(() => import("./pages/auth/login"));
const PasswordForgotPage = lazy(() => import("./pages/auth/forgotPassword"));
const PasswordResetPage = lazy(() => import("./pages/auth/resetPassword"));
const Forbidden = lazy(() => import("./pages/auth/forbidden"));
const Home = lazy(() => import("./pages/home"));
const Dossiers = lazy(() => import("./pages/dossiers"));
const Suppliers = lazy(() => import("./pages/suppliers"));
const DossierDetail = lazy(
  () => import("./pages/dossiers/pages/dossierDetail"),
);
const Users = lazy(() => import("./pages/users"));
const Setup = lazy(() => import("./pages/setup"));
const PaymentResult = lazy(() => import("./pages/payment-result"));
const PriceLists = lazy(() => import("./pages/fileUpload"));
const PriceMarginPage = lazy(() => import("./pages/PriceMargin"));
const ExportsPage = lazy(() => import("./pages/exports"));
const EmailTrackingHistoryPage  = lazy(() => import("./pages/email-tracking"));
const MailingListPage = lazy(() => import("./pages/mailing-list/MailingListPage"));
const MailingListContactsPage = lazy(() => import("./pages/mailing-list/MailingListContactsPage"));

export const routes: RouteType[] = [
  {
    id: "genericError",
    path: "/generic-error",
    titleLocalizationKey: "genericError.title",
    component: GenericError,
    type: type.PUBLIC,
  },
  {
    id: "login",
    path: "/login",
    titleLocalizationKey: "pages.login.title",
    component: Login,
    layout: AuthLayout,
    type: type.AUTHENTICATION,
  },
  {
    id: "passwordForgot",
    path: "/forgot-password",
    titleLocalizationKey: "pages.login.title",
    component: PasswordForgotPage,
    layout: AuthLayout,
    type: type.AUTHENTICATION,
  },
  {
    id: "passwordReset",
    path: "/recovery-password",
    titleLocalizationKey: "pages.reset_password.title",
    component: PasswordResetPage,
    layout: AuthLayout,
  },
  {
    id: "forbidden",
    path: "/forbidden",
    titleLocalizationKey: "pages.forbidden.title",
    component: Forbidden,
    type: type.PUBLIC,
  },
  {
    id: "home",
    path: "/",
    titleLocalizationKey: "pages.home.title",
    component: Home,
    layout: AppLayout,
    type: type.SECURED,
    layoutOptions: {
      hideOnBack: true,
    },
    section: "home",
  },
  // {
  //   id: "dossiers",
  //   path: "/dossiers",
  //   titleLocalizationKey: "pages.dossiers.title",
  //   component: Dossiers,
  //   layout: AppLayout,
  //   type: type.SECURED,
  //   layoutOptions: {
  //     hideOnBack: false,
  //   },
  //   section: "dossiers",
  // },
  // {
  //   id: "dossierDetail",
  //   titleLocalizationKey: "pages.dossiers.title",
  //   path: "/dossiers/:dossierId",
  //   component: DossierDetail,
  //   showInMenu: false,
  //   layout: AppLayout,
  //   type: type.SECURED,
  //   layoutOptions: {
  //     hideOnBack: false,
  //   },
  // },
  {
    id: "users",
    path: "/users",
    titleLocalizationKey: "pages.users.title",
    component: Users,
    layout: AppLayout,
    type: type.SECURED,
    layoutOptions: {
      hideOnBack: false,
    },
    section: "users",
  },
  // {
  //   id: "setup",
  //   path: "/setup",
  //   titleLocalizationKey: "pages.setup.title",
  //   component: Setup,
  //   layout: AppLayout,
  //   type: type.SECURED,
  //   layoutOptions: {
  //     hideOnBack: false,
  //   },
  //   section: "setup",
  // },
  // {
  //   id: "paymentResult",
  //   path: "/payment-result",
  //   titleLocalizationKey: "pages.payment_result.title",
  //   component: PaymentResult,
  //   layout: PublicLayout,
  //   type: type.PUBLIC,
  // },
  {
    id: "suppliers",
    path: "/suppliers",
    titleLocalizationKey: "pages.suppliers.title",
    component: Suppliers,
    layout: AppLayout,
    type: type.SECURED,
    layoutOptions: {
      hideOnBack: false,
    },
    section: "suppliers",
  },
  {
    id: "priceMargin",
    path: "/price-margin",
    titleLocalizationKey: "pages.priceMargin.title",
    component: PriceMarginPage,
    layout: AppLayout,
    type: type.SECURED,
    layoutOptions: {
      hideOnBack: false,
    },
    section: "priceMargin",
  },
  {
    id: "priceLists",
    path: "/upload-price-list",
    titleLocalizationKey: "pages.price_lists.title",
    component: PriceLists,
    layout: AppLayout,
    type: type.SECURED,
    layoutOptions: {
      hideOnBack: false,
    },
    section: "priceLists",
  },
  {
    id: "exports",
    path: "/exports",
    titleLocalizationKey: "pages.export.title",
    component: ExportsPage,
    layout: AppLayout,
    type: type.SECURED,
    layoutOptions: {
      hideOnBack: false,
    },
    section: "exports",
  },
  {
    id: "emailTracking",
    path: "/emailTracking",
    titleLocalizationKey: "pages.emailTracking.title",
    component: EmailTrackingHistoryPage,
    layout: AppLayout,
    type: type.SECURED,
    layoutOptions: {
      hideOnBack: false,
    },
    section: "emailTracking",
  },
  {
    id: "mailingList",
    path: "/mailing-list",
    titleLocalizationKey: "pages.mailingList.title",
    component: MailingListPage,
    layout: AppLayout,
    type: type.SECURED,
    layoutOptions: {
      hideOnBack: false,
    },
    section: "mailingList",
  },
  {
    id: "mailingListContacts",
    path: "/mailing-list/:id/contacts",
    titleLocalizationKey: "pages.mailingListContacts.title",
    component: MailingListContactsPage,
    layout: AppLayout,
    type: type.SECURED,
    layoutOptions: {
      hideOnBack: false,
    },
    section: "mailingListContacts",
  },
];
